declare const __APP_BUILD__: string | undefined;

/** The UTC build time of this page, set by the Vite build. */
export const APP_BUILD = typeof __APP_BUILD__ === "string" ? __APP_BUILD__ : "dev";

/** Increase it with `WEB_BREAK` in `platform/api/app/client_events.py` when old pages must reload (design 21.5). */
export const WEB_BREAK = 1;

export const BUILD_HEADER = "X-Xflow-Build";
export const BREAK_HEADER = "X-Xflow-Web-Break";

type BreakListener = (value: number) => void;
const breakListeners = new Set<BreakListener>();
let serverBreak = 0;

/** The break number in an API answer; a number above the page's own asks for a version check. */
export function noteServerBreak(raw: string | null): void {
  const value = raw === null ? NaN : Number(raw);
  if (!Number.isInteger(value) || value <= serverBreak) return;
  serverBreak = value;
  if (value > WEB_BREAK) breakListeners.forEach((listener) => listener(value));
}

export function onServerBreak(listener: BreakListener): () => void {
  breakListeners.add(listener);
  return () => breakListeners.delete(listener);
}

/** For tests. */
export function resetServerBreak(): void {
  serverBreak = 0;
  breakListeners.clear();
}
